<template>
  <div>
    <CCard>
      <loader v-show="loading" />
      <CCardHeader> <CIcon name="cil-grid" />Outlet </CCardHeader>
      <CCardBody>
        <CRow>
          <CCol>
            <div class="form-group">
              <input
                type="text"
                class="form-control"
                placeholder="Input keyword"
                v-model="keyword"
                @keyup="changeKeyword"
              />
            </div>
          </CCol>
          <CCol>
            <outlet-sort-selector v-model="sort" @input="doSort"/>
          </CCol>
          <CCol col="2">
            <button class="btn btn-primary" v-show="!asc" @click="direction(true)">A to Z</button>
            <button class="btn btn-primary" v-show="asc" @click="direction(false)">Z to A</button>
          </CCol>
        </CRow>
        <div style="overflow: auto">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th rowspan="2">No</th>
                <th rowspan="2">Code / No Urut</th>
                <th rowspan="2">Name</th>
                <th rowspan="2">Phone</th>
                <th colspan="2">Total</th>
                <th rowspan="2">Alamat</th>
                <th rowspan="2" width="50px" align="center"></th>
              </tr>
              <tr>
                <th>Produk</th>
                <th>Transaksi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in items" :key="k">
                <td class="center">
                  <table-number
                    :index="k"
                    :page="paginator.page"
                    :size="paginator.size"
                  />
                </td>
                <td>
                  {{ v.code }}<br/>
                  No. Urut: <span class="code">{{v.id}}</span>
                  <a
                    class="pointer link"
                    @click="generateCode(v)"
                    v-show="v.sub_district_code && v.code.length < 14"
                    >Generate</a
                  >
                  <a
                    class="pointer link"
                    @click="setCode(v)"
                    v-show="v.sub_district_code && v.code.length == 15 && v.set"
                    >Set</a
                  >
                </td>
                <td>{{ v.name }}</td>
                <td>
                  <strong>{{ v.user_name }}</strong
                  ><br />
                  {{ v.user_phone }}
                </td>
                <td class="center"><a class="link" :href="`#/outlet/${v.code}/prod`">{{v.product_count}}</a></td>
                <td class="center"><a class="link" :href="`#/outlet/${v.code}/transaction`">{{v.transaction_count}}</a></td>
                <td>{{ v.address }}</td>
                <td class="center">
                  <CLink
                    href="#"
                    @click="outletDetail(v.code)"
                    v-c-tooltip.hover.click="'Goto Dashboard'"
                  >
                    <CIcon name="cil-arrow-circle-right" size="lg" />
                  </CLink>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CCardFooter>
        <content-pagination :paginator="paginator" @change="changePage" />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber";
import ContentPagination from "../../components/ContentPagination2.vue";
import OutletSortSelector from "../../components/OutletSortSelector.vue";
import { setOutletCode } from "../../lib/helpers";
import Loader from "../../components/Loader";
export default {
  components: {
    TableNumber,
    ContentPagination,
    Loader,
    OutletSortSelector,
  },
  data() {
    return {
      items: [],
      paginator: {},
      loading: false,
      keyword: "",
      sort: {id: 'id', label: 'No Urut'},
      asc: false,
    };
  },
  created() {
    const q = this.$route.query;
    if (q && q.sort) {
      this.sort = JSON.parse(q.sort)
    }
    if (q && q.dir) {
      this.asc = q.dir === 'true' ? false: true;
    }
    this.getList(1, "");
  },
  methods: {
    getList(page, q) {
      this.loading = true;
      let sort = "name:asc"
      let dir = this.asc ? 'asc' : 'desc';
      if (this.sort) {
        sort = `${this.sort.id}:${dir}`;
      }
      HTTPAUTH.get(
        `/api/admin/outlet?page=${page}&size=${10}&sort=${sort}&q=${q}`
      )
        .then((res) => {
          this.items = res.data.data;
          this.paginator = res.data.paginate;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    changePage(p) {
      this.getList(p, "");
    },
    outletDetail(slug) {
      this.$router.push({ path: "/outlet/" + slug + "?menu=outlet" });
      setOutletCode(slug);
    },
    generateCode(v) {
      HTTPAUTH.get("/api/admin/outlet/code/" + v.id).then((res) => {
        v.code = res.data.data.id;
        v.set = true;
      });
    },
    setCode(v) {
      HTTPAUTH.put("/api/admin/outlet/code/" + v.id, {
        code: v.code,
      }).then(() => {
        this.getList(1, "");
      });
    },
    changeKeyword(e) {
      if (e.keyCode == 13) {
        this.getList(1, this.keyword);
      }
    },
    doSort(v) {
      this.sort = v;
      this.$router.push({query: {sort: JSON.stringify(v)}})
      this.getList(1, "")
    },
    direction(asc) {
      this.asc = asc
      this.$router.push({query: {sort: JSON.stringify(this.sort), dir: (asc ? 'asc' : 'desc')}})
      this.getList(1, "")
    }
  },
};
</script>